import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Address } from "@components/atoms";
import { InputSelect, TextField } from "@components/molecules";
import React, { useCallback, useEffect } from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";
import { commonMessages } from "../../../../intl";
export var AddressFormContent = function AddressFormContent(_ref) {
  var address = _ref.address,
      formRef = _ref.formRef,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      formId = _ref.formId,
      backendValidationErrors = _ref.backendValidationErrors,
      errors = _ref.errors,
      handleSubmit = _ref.handleSubmit,
      toDelete = _ref.toDelete,
      values = _ref.values,
      countriesOptions = _ref.countriesOptions,
      defaultValue = _ref.defaultValue,
      setFieldValue = _ref.setFieldValue,
      _ref$includeEmail = _ref.includeEmail,
      includeEmail = _ref$includeEmail === void 0 ? false : _ref$includeEmail,
      setAccountType = _ref.setAccountType,
      accountType = _ref.accountType;
  var intl = useIntl();
  var basicInputProps = useCallback(function () {
    return {
      onBlur: handleBlur,
      onChange: handleChange
    };
  }, [handleChange, handleBlur]);
  var fieldErrors = {};
  useEffect(function () {
    if ((address === null || address === void 0 ? void 0 : address.companyName) && (address === null || address === void 0 ? void 0 : address.vatNumber)) {
      setAccountType("company");
    }
  }, []);

  function accountTypeHandler(type) {
    setAccountType(type);
  }

  if (backendValidationErrors) {
    backendValidationErrors.forEach(function (_ref2) {
      var field = _ref2.field,
          message = _ref2.message;
      fieldErrors[field] = fieldErrors[field] ? [].concat(_toConsumableArray(fieldErrors[field]), [{
        message: message
      }]) : [{
        message: message
      }];
    });
  }

  if (errors) {
    Object.keys(errors).forEach(function (field) {
      fieldErrors[field] = fieldErrors[field] ? [].concat(_toConsumableArray(fieldErrors[field]), [{
        message: errors[field]
      }]) : [{
        message: errors[field]
      }];
    });
  }

  var isDefaultAddress = function isDefaultAddress(billing, shipping) {
    if (billing && shipping) {
      return intl.formatMessage({
        defaultMessage: "Default Address",
        "id": "@next.components.organisms.AddressForm.AddressFormContent.1224809208"
      });
    }

    if (shipping) {
      return intl.formatMessage({
        defaultMessage: "Default Shipping Address",
        "id": "@next.components.organisms.AddressForm.AddressFormContent.4109348993"
      });
    }

    if (billing) {
      return intl.formatMessage({
        defaultMessage: "Default Billing Address",
        "id": "@next.components.organisms.AddressForm.AddressFormContent.1578192486"
      });
    }

    return "";
  };

  return React.createElement(S.AddressForm, {
    className: "address-form",
    id: formId,
    ref: formRef,
    onSubmit: handleSubmit
  }, React.createElement(S.Wrapper, null, toDelete ? React.createElement(S.DeleteContainer, null, React.createElement(S.DeleteBody, {
    isDefaultShippingAddress: true,
    isDefaultBillingAddress: true
  }, React.createElement("div", null, isDefaultAddress(address === null || address === void 0 ? void 0 : address.isDefaultBillingAddress, address === null || address === void 0 ? void 0 : address.isDefaultShippingAddress)), React.createElement(S.AddressField, null, React.createElement(Address, address)))) : React.createElement(React.Fragment, null, React.createElement(S.Tabs, null, React.createElement(S.TabsTitle, null, intl.formatMessage(_defineProperty({
    defaultMessage: "I want to order as a:",
    "id": "@next.components.organisms.AddressForm.AddressFormContent.512744385"
  }, "id", "@next.components.organisms.AddressForm.AddressFormContent.512744385"))), React.createElement(S.TabsButtonsWrapper, null, React.createElement(S.TabsButton, {
    active: accountType === "person",
    type: "button",
    onClick: function onClick() {
      return accountTypeHandler("person");
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Person",
    "id": "@next.components.organisms.AddressForm.AddressFormContent.1225883824"
  }, "id", "@next.components.organisms.AddressForm.AddressFormContent.1225883824"))), React.createElement(S.TabsButton, {
    active: accountType === "company",
    type: "button",
    onClick: function onClick() {
      return accountTypeHandler("company");
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Company",
    "id": "@next.components.organisms.AddressForm.AddressFormContent.3570415321"
  }, "id", "@next.components.organisms.AddressForm.AddressFormContent.3570415321"))))), accountType === "company" && React.createElement(S.RowWithTwoCells, null, React.createElement(TextField, _extends({
    "data-cy": "addressFormCompanyName",
    name: "companyName",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Company Name",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.2953060418"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.2953060418")),
    value: values.companyName,
    autoComplete: "organization",
    errors: fieldErrors.companyName
  }, basicInputProps())), React.createElement(TextField, _extends({
    name: "vatNumber",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "VAT Number",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.2306051420"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.2306051420")),
    value: values.vatNumber,
    errors: fieldErrors.vatNumber
  }, basicInputProps()))), React.createElement(S.RowWithTwoCells, {
    margin: true
  }, React.createElement(TextField, _extends({
    "data-cy": "addressFormFirstName",
    name: "firstName",
    label: intl.formatMessage(commonMessages.firstName),
    value: values.firstName,
    autoComplete: "given-name",
    errors: fieldErrors.firstName
  }, basicInputProps())), React.createElement(TextField, _extends({
    "data-cy": "addressFormLastName",
    name: "lastName",
    label: intl.formatMessage(commonMessages.lastName),
    value: values.lastName,
    autoComplete: "family-name",
    errors: fieldErrors.lastName
  }, basicInputProps()))), includeEmail && React.createElement(S.RowWithOneCell, null, React.createElement(TextField, _extends({
    "data-cy": "addressFormEmail",
    name: "email",
    placeholder: intl.formatMessage(commonMessages.smallEmail),
    value: values.email,
    autoComplete: "email",
    errors: fieldErrors.email
  }, basicInputProps()))), React.createElement(S.RowWithOneCell, {
    margin: true
  }, React.createElement(TextField, _extends({
    "data-cy": "addressFormPhone",
    name: "phone",
    label: intl.formatMessage(commonMessages.phone),
    value: values.phone,
    autoComplete: "tel",
    errors: fieldErrors.phone
  }, basicInputProps()))), React.createElement(S.RowWithOneCell, null, React.createElement(TextField, _extends({
    "data-cy": "addressFormStreetAddress1",
    name: "streetAddress1",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Address line 1",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.1363074570"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.1363074570")),
    value: values.streetAddress1,
    autoComplete: "address-line1",
    errors: fieldErrors.streetAddress1
  }, basicInputProps()))), React.createElement(S.RowWithOneCell, null, React.createElement(TextField, _extends({
    "data-cy": "addressFormStreetAddress2",
    name: "streetAddress2",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Address line 2",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.3121963259"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.3121963259")),
    value: values.streetAddress2,
    autoComplete: "address-line2",
    errors: fieldErrors.streetAddress2
  }, basicInputProps()))), React.createElement(S.RowWithTwoCells, null, React.createElement(TextField, _extends({
    "data-cy": "addressFormCity",
    name: "city",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "City",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.253031977"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.253031977")),
    value: values.city,
    autoComplete: "address-level1",
    errors: fieldErrors.city
  }, basicInputProps())), React.createElement(TextField, _extends({
    "data-cy": "addressFormPostalCode",
    name: "postalCode",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "ZIP/Postal Code",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.2796540622"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.2796540622")),
    value: values.postalCode,
    autoComplete: "postal-code",
    errors: fieldErrors.postalCode
  }, basicInputProps()))), React.createElement(S.RowWithTwoCells, {
    className: "address-form-country"
  }, React.createElement(InputSelect, {
    inputProps: {
      "data-cy": "addressFormCountry"
    },
    defaultValue: defaultValue,
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Country",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.1139500589"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.1139500589")),
    name: "country",
    options: countriesOptions,
    value: values.country && countriesOptions && countriesOptions.find(function (option) {
      return option.code === values.country.code;
    }),
    onChange: function onChange(value, name) {
      return setFieldValue(name, value);
    },
    optionLabelKey: "country",
    optionValueKey: "code",
    errors: fieldErrors.country
  }), React.createElement(TextField, _extends({
    "data-cy": "addressFormCountryArea",
    name: "countryArea",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "State/province",
      "id": "@next.components.organisms.AddressForm.AddressFormContent.404705399"
    }, "id", "@next.components.organisms.AddressForm.AddressFormContent.404705399")),
    value: values.countryArea,
    autoComplete: "address-level2",
    errors: fieldErrors.countryArea
  }, basicInputProps()))))));
};